<script setup lang="ts">
import { computed } from "vue";
import { getEnvironmentBanner } from "@/services/environment";

const banner = computed(() => getEnvironmentBanner());
</script>

<template>
  <VSystemBar v-if="banner" rounded="0" :style="{ backgroundColor: banner.backgroundColor }" class="environment-banner">
    <span class="environment-banner__label">{{ banner.label }}</span>
  </VSystemBar>
</template>

<style scoped>
.environment-banner {
  justify-content: center;
}

.environment-banner__label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: black;
}
</style>
